import { THEME_DEFAULT } from './themes/default/theme';

export const THEME = {
    DEFAULT: THEME_DEFAULT
};
